import React         from 'react'
import { Glyphicon } from 'react-bootstrap'

import Panel         from './panel'

export default class InputGroup extends React.Component
  constructor: (props) ->
    super(props)

    @state = { collapsed: props.collapsed or false }

  render: ->
    <Panel header={@header()} bsStyle={@props.bsStyle or 'info'}>
      {@props.children unless @state.collapsed}
    </Panel>

  header: ->
    <div>
      {@props.title}
      {@collapseToggle()}
    </div>

  collapseToggle: ->
    <span className='pull-right'>
      <Glyphicon glyph='plus' onClick={=> @setState(collapsed: !@state.collapsed)} />
    </span>
